import { APPROVE_CHECK, FAIL_CHECK } from './actionTypes';
import { getUserInfo } from './user';
import auth from '../utils/auth';
import toFinish from '../utils/toFinish';
import { getOrganisationsInfo } from './organisation';

const failCheck = () => ({
  type: FAIL_CHECK,
});

const approveCheck = () => ({
  type: APPROVE_CHECK,
});

export const checkInit = () => async (dispatch, getState) => {
  if (auth.hasTokens()) {
    if (!getState().user.id) {
      const [userError] = await toFinish(dispatch(getUserInfo()));
      if (userError) {
        return dispatch(failCheck());
      }
      console.log('getUserError', userError);
      const { user } = getState();
      const [orgError] = await toFinish(dispatch(getOrganisationsInfo(user.organisationsId)));
      console.log('getOrgError', orgError);
      if (orgError) {
        return dispatch(failCheck());
      }
    }
    return dispatch(approveCheck());
  }
  return dispatch(failCheck());
};



// WEBPACK FOOTER //
// ./src/actions/app.js